import React, { FC } from 'react';
import styles from './DashboardCard.module.scss';

interface DashboardCardProps {
	icon: JSX.Element;
	title: string;
	value: string | number;
	color?: string;
	backgroundColor?: string;
}

const DashboardCard: FC<DashboardCardProps> = ({
	icon,
	title,
	value,
	color = '',
	backgroundColor = '',
}): JSX.Element => (
	<section
		className={`${styles.DashboardCard}`}
		style={{ backgroundColor: backgroundColor, color: color, fill: color }}
	>
		<div className={styles.TitleSection}>
			<span className={`${styles.Icon}`}>{icon}</span>
			<span className={`${styles.Title}`}>{title}</span>
		</div>
		<p className={`${styles.Value}`}>{value}</p>
	</section>
);

export { DashboardCard };
